import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Feedback } from '../../../core/services/satisfaction.service';
import { ConfirmModalComponent } from '../../../component/confirm-modal/confirm-modal.component';
import { TimezoneService } from '../../../core/services/timezone.service';
import { formatInTimeZone } from 'date-fns-tz';

@Component({
  selector: 'app-call-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ConfirmModalComponent, TranslatePipe],
  templateUrl: './call-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./call-modal.component.scss']
})
export class CallModalComponent {
  private timezone = inject(TimezoneService);

  @Input() show = false;
  @Input() feedback: Feedback | null = null;
  
  @Output() close = new EventEmitter<void>();
  @Output() markAsCalled = new EventEmitter<{feedbackId: string, voicemailContent: string}>();
  @Output() noReply = new EventEmitter<void>();

  patientContacted = false;
  voicemailContent = '';
  showConfirmNoReply = false;

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const formatted = formatInTimeZone(date, this.timezone.getEstablishmentTimezone(), 'dd/MM/yyyy HH:mm');
    return `${formatted}${this.timezone.getTimezoneHint(date)}`;
  }

  onClose() {
    this.patientContacted = false;
    this.voicemailContent = '';
    this.close.emit();
  }

  onMarkAsCalled() {
    if (this.patientContacted && this.feedback) {
      this.markAsCalled.emit({
        feedbackId: this.feedback.feedback_id,
        voicemailContent: this.voicemailContent
      });
    }
    this.patientContacted = false;
    this.voicemailContent = '';
    this.close.emit();
  }

  onNoReply() {
    this.showConfirmNoReply = true;
  }

  onConfirmNoReply() {
    this.showConfirmNoReply = false;
    this.patientContacted = false;
    this.voicemailContent = '';
    this.noReply.emit();
    this.close.emit();
  }

  onCancelNoReply() {
    this.showConfirmNoReply = false;
  }
}